const $ = jQuery.noConflict();

'use strict';
const Banner = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	$domBanner: $('.js-banner'),
	$domButtonsBanner: $('.js-banner__button-box'),
	$domBannerContainer: $('.js-banner__container'),

	$domBannerTextRegular: $('.js-banner--regular'),
	$domBannerTextRegularImageBox: $('.js-banner--regular').find('.js-banner-text__background'),
	$domBannerTextRegularWrapp: $('.js-banner--regular').find('.js-banner-text__wrapp-content'),
	$domBannerTextRegularOverlay: $('.js-banner--regular').find('.js-banner-text__content-overlay'),

	/** @description Initialize */
	init: function() {
		this.appendBannerView();
		this.appendBannerTextView();
		this.videoTransitions();

		$(window).on('resize', function() {
			Banner.appendBannerView();
			Banner.appendBannerTextView();
		});
	},

	appendBannerView: function() {
		if($(window).width() > 1920) {
			this.$domButtonsBanner.appendTo(this.$domBannerContainer);
		}else {
			this.$domButtonsBanner.appendTo(this.$domBanner);
		}
	},

	appendBannerTextView: function() {
		if($(window).width() < 641) {
			this.$domBannerTextRegularImageBox.appendTo(this.$domBannerTextRegularWrapp);
		}else {
			this.$domBannerTextRegularImageBox.appendTo(this.$domBannerTextRegularOverlay);
		}
	},

	//Video transitions for Banner on homepage
	videoTransitions: function() {
		const homepageBannerVideo = $('#background-video');
		const homepageBannerVideoContainer = $('.js-banner__video-container');
		const homepageBannerTitle = $('.js-banner__caption-title');
		const homepageBannerSubtitle = $('.js-banner__caption-subtitle');
		const homepageBannerText = $('.js-banner__caption-text');
		const playButton = $('.js-banner__video-play-button');
		const header = $('.site-header');
		const body = $('body.home');

		let opacityTimeout = 1000;
		let showVideoTimeout = 1500;
		let moveVideoTimeout = 3500;
		let overlayTimeout = 5500;
		let headerTimeout = 6000;
		let titleTimeout = 6500;
		let subtitleTimeout = 6900;
		let textTimeout = 7400;

		if($(window).width() < 1600) {
			let increment = 200;
			opacityTimeout = opacityTimeout + increment;
			showVideoTimeout = showVideoTimeout + increment;
			moveVideoTimeout = moveVideoTimeout + increment;
			overlayTimeout = overlayTimeout + increment;
			headerTimeout = headerTimeout + increment;
			titleTimeout = titleTimeout + increment;
			subtitleTimeout = subtitleTimeout + increment;
			textTimeout = textTimeout + increment;
		}

		if(homepageBannerVideo.length > 0) {
			setTimeout(() => {
				body.addClass('remove-opacity');//removes opacity from site
			}, opacityTimeout);
			setTimeout(() => {
				homepageBannerVideoContainer.addClass('show-video-container');
			}, showVideoTimeout);
			setTimeout(() => {
				$('html, body').animate({scrollTop: 0}, 'fast');
				homepageBannerVideoContainer.addClass('move-video-container');
			}, moveVideoTimeout);
			setTimeout(() => {
				body.addClass('remove-overlay');
			}, overlayTimeout);
			setTimeout(() => {
				header.addClass('show-header');
				playButton.addClass('show-button');
			}, headerTimeout);
			setTimeout(() => {
				homepageBannerTitle.addClass('show-text');
				playButton.addClass('pulse-effect');
			}, titleTimeout);
			setTimeout(() => {
				body.addClass('remove-overflow');
				homepageBannerSubtitle.addClass('show-text');
			}, subtitleTimeout);
			setTimeout(() => {
				homepageBannerText.addClass('show-text');
			}, textTimeout);
		}
	},
};

export default Banner;
